import { Helmet } from "react-helmet";
import {
  Box,
  Collapse,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/icons/chevron-expand-up.svg";
import * as Util from "../../../../services/global.service";
const useStyles = makeStyles({
});


const DefaultForm = (props) => {
  const { data, key } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(true);
  let onChangeOpen = () => {
    setOpen(!open)
  }
  return (
    <Box key={key}>
      <Box sx={{ display: "flex", alignItems: "center", height: "50px", borderBottom: "1px solid #E5E5E5" }}>
        <Box ml="7px" mr="12px" sx={{ background: "#F5F5F5", borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={onChangeOpen}>
          {open ? <ChevronUp /> : <ChevronDown />}
        </Box>
        <Typography width="calc(57.03% - 44px)" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {Util.formatData(data?.name, "")}
        </Typography>
        <Typography width="21.26%" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {data?.is_probation === true ? t('label.employeeStartDate') : Util.formatData(data?.start_date, "") !== "" ? Util.dateDayFormatAdmin(data?.start_date) : ""}
        </Typography>
        <Typography width="21.71%" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {data?.is_probation === true ? Util.formatData(data?.steps, []).length > 0 ? Util.formatData(data?.steps[data?.steps.length - 1]?.duration, 0) + " " + t('label.daysFromStartDate') : "0 " + t('label.daysFromStartDate') : Util.formatData(data?.end_date, "") !== "" ? Util.dateDayFormatAdmin(data?.end_date) : ""}
        </Typography>
      </Box>
      <Collapse in={open}>
        {Util.formatData(data?.steps, []).length > 0 ? data?.steps.map((row, index) => (
          <Box sx={{ display: "flex", alignItems: "center", height: "50px", }}>
            <Typography width="calc(57.03% - 32px)" height="50px" ml="32px" pl="12px" pr="20px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {Util.formatData(row?.name, " ")}
            </Typography>
            <Typography width="21.26%" pr="20px" height="50px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {data?.is_probation === true ? t('label.employeeStartDate') : Util.formatData(row?.start_at, "") !== "" ? Util.dateDayFormatAdmin(row?.start_at) : " "}
            </Typography>
            <Typography width="21.71%" pr="20px" height="50px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {data?.is_probation === true ? Util.formatData(row?.duration, 0) + " " + t('label.daysFromStartDate') : Util.formatData(row?.end_at, "") !== "" ? Util.dateDayFormatAdmin(row?.end_at) : " "}
            </Typography>
          </Box>
        ))
          :
          null
        }
      </Collapse>
    </Box>
  );
};
export default DefaultForm;
